import React from "react";

// Leyenda "Departamento responsable: X" — reutilizada en el pie de cada sección del
// expediente, junto a CRM_LeyendaAuditoria. Recibe el listado responsable_departamento
// (mdl_Dep_Responsable_Seccion_CRM) de GetInfoClienteID y el idrel de la sección a mostrar.
export const CRM_LeyendaDepartamento = ({ responsables = [], idrel, className = "" }) => {
  const responsable = responsables.find((r) => Number(r.idrel) === Number(idrel));
  if (!responsable?.departamento) return null;

  return (
    <div className={`crm-leyenda-departamento${className ? ` ${className}` : ""}`}>
      Departamento responsable: <strong>{responsable.departamento}</strong>
    </div>
  );
};
